<div id="rightSideBar" [hidden]="!selectedItems || selectedItems.length == 0">
    <div class="rightSidePanel d-flex flex-column w-70pc">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ panelHeading }}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-primary mr-2" [ngClass]="{'disabled': disableSave }" (click)="assignGradeToEmployee()">
                    {{ 'save_text' | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div>
            <div class="block mt-2">
                <div class="row padding-top-10">
                    <div class="col-md-4 no-padding-right-left">
                        <div class="input-group">
                            <ng-select class="solo-dropdown filterDropdown" [items]="gradeAllList" bindLabel="gradeName"
                                bindValue="gradeId" placeholder="Grade Name" [clearable]="false" [selectOnTab]="true"
                                required-field [(ngModel)]="assignedGradeId" (change)="onGradeChange()"
                                notFoundText="{{ 'no_data_available' | translate }}">
                            </ng-select>
                        </div>
                        <div class="d-block mt-1" *ngIf="assignedGradeId">
                            <small>
                                <span><strong>{{ 'no_of_claimants' | translate }}:</strong> {{assignedEmployeeCount}}
                                </span>
                            </small>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <span>
                            <button class="btn btn-primary f-13"
                                [ngClass]="{'disabled bg-secondary opacity-60': disableAssign}" (click)="assignGrade()">
                                {{ "label_assign" | translate }}
                            </button>
                        </span>
                    </div>
                    <div class="col-md-7">
                        <span class="position-relative fw-600 text-logo-blue lH-30">{{ anyTextForDisplay }}</span>
                    </div>
                </div>
            </div>
            <div class="block heightCalc-14">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 no-padding-right-left heightCalc-17">
                        <h6 class="text-charcoal-black fw-700 f-14">
                            {{ selectedItemsText }}:
                        </h6>

                        <!----------------------Start Grid--------------------------->
                        <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
                            (onCellClick)="fnOnGridCellClick($event)">
                        </app-grid>
                        <!----------------------End Grid--------------------------->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>